import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VeeValidate from "vee-validate/dist/vee-validate.min.js";
import "./registerServiceWorker";
import {
  Button,
  Input,
  Numberinput,
  Field,
  Icon,
  Switch,
  Collapse,
  Toast,
  Radio,
  Dropdown,
  Modal,
  Tabs,
  Taginput,
  Progress,
  Autocomplete,
  Dialog,
  Upload,
  Checkbox,
  Loading,
  Select
} from "buefy";
import "buefy/dist/buefy.css";
import VueWindowSize from "vue-window-size";
import VueSocketIO from "vue-socket.io";
import VueYoutube from "vue-youtube";
import linkify from "vue-linkify";

// import CookieLaw from "vue-cookie-law";
import VueObserveVisibility from "vue-observe-visibility";

import i18n from "./i18n";

Vue.config.productionTip = false;

Vue.use(Button);
Vue.use(Input);
Vue.use(Numberinput);
Vue.use(Field);
Vue.use(Icon);
Vue.use(Switch);
Vue.use(Collapse);
Vue.use(Toast);
Vue.use(Radio);
Vue.use(Dropdown);
Vue.use(Modal);
Vue.use(Tabs);
Vue.use(Taginput);
Vue.use(Progress);
Vue.use(Upload);
Vue.use(Checkbox);
Vue.use(Autocomplete);
Vue.use(Loading);
Vue.use(Dialog);
Vue.use(Select);

Vue.use(VeeValidate);
Vue.use(VueWindowSize);

Vue.use(VueYoutube);

// Vue.component("cookie-law", CookieLaw);

Vue.use(VueObserveVisibility);

Vue.directive("linkified", linkify);

Object.defineProperty(String.prototype, "hashCode", {
  value: function() {
    var hash = 0,
      i,
      chr;
    if (this.length === 0) return hash;
    for (i = 0; i < this.length; i++) {
      chr = this.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash < 0 ? hash * -1 : hash;
  }
});

Object.defineProperty(String.prototype, "capitalize", {
  value: function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false
});

Object.defineProperty(String.prototype, "startText", {
  value: function(start) {
    return this.substring(start, this.length + 1).capitalize();
  }
});

Object.defineProperty(String.prototype, "toCorrectDomain", {
  value: function() {
    try {
      var domainArray = this.split(".");
      var hostArray = window.location.host.split(".");

      if (domainArray.length < 2 || hostArray.length < 2) {
        return this;
      }

      var baseDomain = domainArray[1];
      var hostBaseDomain = hostArray[1];

      return this.replace(baseDomain, hostBaseDomain);
    } catch (error) {
      console.log(error);
      return this;
    }
  }
});

Object.defineProperty(String.prototype, "initials", {
  value: function() {
    const allNames = this.trim().split(" ");
    const initials = allNames.reduce((acc, curr, index) => {
      if (index === 0 || index === allNames.length - 1) {
        acc = `${acc}${curr.charAt(0).toUpperCase()}`;
      }
      return acc;
    }, "");
    return initials;
  },
  enumerable: false
});

Object.defineProperty(String.prototype, "firstChar", {
  value: function() {
    return this.substring(0, 1);
  },
  enumerable: false
});

Vue.use(
  new VueSocketIO({
    debug: true,
    connection: `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}` //options object is Optional
  })
);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
